import { render, staticRenderFns } from "./AddTranslationPopup.vue?vue&type=template&id=44401a3a&scoped=true"
import script from "./AddTranslationPopup.vue?vue&type=script&lang=js"
export * from "./AddTranslationPopup.vue?vue&type=script&lang=js"
import style0 from "./AddTranslationPopup.vue?vue&type=style&index=0&id=44401a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44401a3a",
  null
  
)

export default component.exports